module.exports = __webpack_public_path__ + "img/title-background.883e87c4.svg";